import { createAction, props } from '@ngrx/store';

export const setPeekingAssistantDisabled = createAction(
  '[Peeking Assistant] Set disabled',
  props<{ disabled: boolean }>()
);

export const setPeekingAssistantFundType = createAction(
  '[Peeking Assistant] Set fund type',
  props<{ fund_type: 'fund' | 'rfp' }>()
);
